import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import PageSlider from '@/components/PageSliders/pageSlider';
import Home from './Home/home';
import './app.css';
import Apresentacao from './Apresentacao/apresentacao';
function App() {
    return (_jsxs(PageSlider, { children: [_jsx(Home, {}), _jsx(Apresentacao, {})] }));
}
export default App;
